import { $_app_server } from '@/_helpers'
let ApiServer = $_app_server

let ApiPresets = Object.freeze({
  headers: {
    MULTIPART: {
      headers: {'Content-Type': 'multipart/form-data'}
    },
  },
})

let get = (path) => (config = {}) => {
  return $_app_server.get(path, config).then(response => response.data)
}
let blob = (path) => () => {
  return $_app_server.get(path, { responseType: 'blob' })
}
let post = (path) => (data, config = {}) => {
  return $_app_server.post(path, data, config).then(response => response.data)
}
let put = (path) => (data, config = {}) => {
  return $_app_server.put(path, data, config).then(response => response.data)
}
let patch = (path) => (data, config = {}) => {
  return $_app_server.patch(path, data, config).then(response => response.data)
}
let del = (path) => (config = {}) => {
  return $_app_server.delete(path, config).then(response => response.data)
}

// $_app_server_noAuth
let factory = function (init) {
  let factoryHandler = {
    get (target, prop) {
      let path = target.path || init
      
      if (prop === 'path') return path
      else if (prop == 'get') return get(path)
      else if (prop == 'post') return post(path)
      else if (prop == 'put') return put(path)
      else if (prop == 'patch') return patch(path)
      else if (prop == 'delete') return del(path)
      else if (prop == 'blob') return blob(path)

      let next = { path: `${path}/${prop}`}
      if (prop.startsWith('?')) next = { path: `${path}${prop}`}
      
      return new Proxy(next, factoryHandler)
    }
  }

  return new Proxy({}, factoryHandler)
}

export const ApiProxy = (obj) => new Proxy(obj, {
  get (target, prop) {
    // target({ Factory: ApiFactory, Presets: ApiPresets, Server: ApiServer })
    return target[prop]({ Factory: factory(prop), Presets: ApiPresets, Server: ApiServer })
  }
})